/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import {
  buildEvolucaoStackedSeries,
  evolucaoHasData,
  mapEvolucaoToDataset,
} from './constants';
import { ChartEmpty, CHART_HEIGHT } from './chartShared';

const EvolucaoChart = ({ items, loading, height }) => {
  const dataset = useMemo(() => mapEvolucaoToDataset(items), [items]);
  const series = useMemo(() => buildEvolucaoStackedSeries(), []);
  const hasData = evolucaoHasData(dataset);
  const chartHeight = height || CHART_HEIGHT;

  if (loading) {
    return <Skeleton variant="rounded" height={chartHeight} sx={{ borderRadius: 2 }} />;
  }

  if (!hasData) {
    return <ChartEmpty message="Sem custos no período selecionado" />;
  }

  return (
    <Box sx={{ width: '100%' }} aria-label="Gráfico de evolução mensal de custos">
      <BarChart
        dataset={dataset}
        xAxis={[{ scaleType: 'band', dataKey: 'mesLabel' }]}
        series={series}
        height={chartHeight}
        margin={{ left: 56, right: 16, top: 16, bottom: 32 }}
        slotProps={{
          legend: {
            direction: 'row',
            position: { vertical: 'bottom', horizontal: 'middle' },
            padding: 0,
          },
        }}
      />
    </Box>
  );
};

EvolucaoChart.propTypes = {
  items: PropTypes.array,
  loading: PropTypes.bool,
  height: PropTypes.number,
};

EvolucaoChart.defaultProps = {
  items: [],
  loading: false,
  height: null,
};

export default EvolucaoChart;
